export const ROWS_PER_PAGE = [5, 10, 25, 50];
